/** The collapsible parts of the offer form. */
export enum OfferFormPanel {
  PRODUCT = 'PRODUCT',
  PRODUCT_DETAILS = 'PRODUCT_DETAILS',
  ADD_ONS = 'ADD_ONS',
  CUSTOMER = 'CUSTOMER',
  PAYMENT = 'PAYMENT',
  OFFER_FILE = 'OFFER_FILE'
}
